import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/Star';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import { tiers } from '../../constants';

import axios from 'axios'

import { useAppSelector } from './../../hooks'
import { CircularProgress } from '@mui/material';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://mui.com/">
                Flourish, LLC
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const footers = [
    {
        title: 'Company',
        description: ['Team', 'History', 'Contact us', 'Locations'],
    },
    {
        title: 'Features',
        description: [
            'Cool stuff',
            'Random feature',
            'Team feature',
            'Developer stuff',
            'Another one',
        ],
    },
    {
        title: 'Resources',
        description: ['Resource', 'Resource name', 'Another resource', 'Final resource'],
    },
    {
        title: 'Legal',
        description: ['Privacy policy', 'Terms of use'],
    },
];

function PricingContent() {

    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    const [currentSubscription, setCurrentSubscription] = useState<number>(0)
    const [currentSubscriptionPlanName, setCurrentSubscriptionPlanName] = useState<'None' | 'Bronze' | 'Silver' | 'Gold' | 'Platinum' | 'Custom'>('None')

    const [loadingStripeCheckoutPage, setLoadingStripeCheckoutPage] = useState<boolean>(false)

    useEffect(() => {
        console.log(process.env)
    }, [])

    useEffect(() => {
        if (selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.latentSubscription) {
            setCurrentSubscription(selectedStaffProfile.organization.latentSubscription)
            if (selectedStaffProfile.organization.latentSubscription == 1) setCurrentSubscriptionPlanName('Bronze')
            else if (selectedStaffProfile.organization.latentSubscription == 2) setCurrentSubscriptionPlanName('Silver')
            else if (selectedStaffProfile.organization.latentSubscription == 3) setCurrentSubscriptionPlanName('Gold')
            else if (selectedStaffProfile.organization.latentSubscription == 4) setCurrentSubscriptionPlanName('Platinum')
            else setCurrentSubscriptionPlanName('Custom')
        }
    }, [selectedStaffProfile])

    return (
        <React.Fragment>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            {/* Hero unit */}
            <Container disableGutters maxWidth="sm" component="main" sx={{ pt: 8, pb: 6 }}>
                <Typography
                    component="h1"
                    variant="h2"
                    align="center"
                    color="text.primary"
                    gutterBottom
                >
                    Subscription
                </Typography>
                <Typography variant="h5" align="center" color="text.secondary" component="p">
                    View and manage your current subscription plan from this page
                </Typography>
            </Container>
            <Container maxWidth="lg" component="main">
                <Grid container alignItems="flex-end">
                    <Grid
                        item
                        key={'demo'}
                        xs={12}
                        sx={{ borderRadius: 15 }}
                        className=" bg-dark row mb-5 p-4"
                    >
                        <div className="col-12 col-lg-8">
                            <div className="d-flex flex-column justify-content-center align-items-start h-100">
                                <CardContent className="py-0">
                                    <Typography variant="h5" component="div" color="white">
                                        Contact sales if you have questions about your subscription plan or want to change plans.
                                    </Typography>
                                </CardContent>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                <CardContent className="py-0">
                                    <Button variant="contained" color="secondary" sx={{ backgroundColor: 'white', color: 'black' }} onClick={() => {
                                        // @ts-ignore
                                        window.Tawk_API.maximize()
                                    }}>Contact sales</Button>
                                </CardContent>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
            {/* End hero unit */}
            <Container maxWidth="lg" component="main">
                <div className="d-flex flex-row justify-content-center mb-5">
                    <Typography variant="h4">{currentSubscriptionPlanName != 'None' ? `You're currently subscribed to the ${currentSubscriptionPlanName} plan.` : ''}</Typography>
                </div>
                <Grid container spacing={5} alignItems="center" className="h-100">
                    {tiers.map((tier) => (
                        // Enterprise card is full width at sm breakpoint
                        <Grid
                            item
                            key={tier.title}
                            xs={12}
                            sm={tier.title === 'Enterprise' ? 12 : 6}
                            md={3}
                            className="h-100"
                        >
                            <Card className="shadow h-100">
                                <CardHeader
                                    title={tier.title}
                                    subheader={tier.subheader}
                                    titleTypographyProps={{ align: 'center' }}
                                    // action={tier.title === 'Pro' ? <StarIcon /> : null}
                                    subheaderTypographyProps={{
                                        align: 'center',
                                        color: 'lightgray'
                                    }}
                                    sx={{
                                        backgroundColor: 'black',
                                        color: 'white'
                                    }}
                                />
                                <CardContent>
                                    {
                                        tier.title != 'Enterprise' ?
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'baseline',
                                                    mb: 2,
                                                }}
                                            >
                                                <Typography component="h2" variant="h3" color="text.primary">
                                                    ${tier.price}
                                                </Typography>
                                                <Typography variant="h6" color="text.secondary">
                                                    /mo
                                                </Typography>
                                            </Box>
                                            :
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    mb: 2,
                                                }}
                                            >
                                                <Typography component="h2" variant="h3" color="text.primary">
                                                    Custom pricing
                                                </Typography>
                                            </Box>
                                    }
                                    <ul>
                                        {tier.description.map((line, key) => (
                                            <Typography
                                                component="li"
                                                variant="subtitle1"
                                                align="center"
                                                key={line}
                                            >
                                                {key == 0 ? <em>{line}</em> : `• ${line}`}
                                            </Typography>
                                        ))}
                                    </ul>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        disabled={currentSubscription > 0 || loadingStripeCheckoutPage}
                                        fullWidth
                                        variant={tier.buttonVariant as 'outlined' | 'contained'}
                                        onClick={async () => {
                                            if (selectedStaffProfile && selectedStaffProfile.organizationID) {
                                                if (tier.title == 'Starter') {
                                                    setLoadingStripeCheckoutPage(true)
                                                    const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/stripe/create-checkout-session`, {
                                                        product: 'Latent',
                                                        price: process.env.REACT_APP_ENV == 'prod' ? 'price_1KydTMBho1eq7jiZp8FqgyDz' : 'price_1KydWVBho1eq7jiZwRcZmHLA',
                                                        successURL: `${window.location.href}`,
                                                        cancelURL: `${window.location.href}`,
                                                        transactionName: `Latent Subscription`,
                                                        metadata: {
                                                            for: 'LatentOrganizationSubscription',
                                                            organizationID: selectedStaffProfile?.organizationID
                                                        }
                                                    })
                                                    setLoadingStripeCheckoutPage(false)
                                                    console.log(response)
                                                    if (response.data && response.data && response.data.session && response.data.session.url) {
                                                        window.location.href = response.data.session.url
                                                    }
                                                } else if (tier.title == 'Pro') {
                                                    setLoadingStripeCheckoutPage(true)
                                                    const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/stripe/create-checkout-session`, {
                                                        product: 'Latent',
                                                        price: process.env.REACT_APP_ENV == 'prod' ? 'price_1KydTMBho1eq7jiZ39ztgOY2' : 'price_1KydWVBho1eq7jiZturHEHvL',
                                                        successURL: `${window.location.href}`,
                                                        cancelURL: `${window.location.href}`,
                                                        transactionName: `Latent Subscription`,
                                                        metadata: {
                                                            for: 'LatentOrganizationSubscription',
                                                            organizationID: selectedStaffProfile?.organizationID
                                                        }
                                                    })
                                                    setLoadingStripeCheckoutPage(false)
                                                    console.log(response)
                                                    if (response.data && response.data && response.data.session && response.data.session.url) {
                                                        window.location.href = response.data.session.url
                                                    }
                                                } else if (tier.title == 'Enterprise') {
                                                    // @ts-ignore
                                                    window.Tawk_API.maximize()
                                                }
                                            }
                                        }}
                                    >
                                        {
                                            loadingStripeCheckoutPage ?
                                                <CircularProgress color={tier.title == 'Pro' ? 'secondary' : 'primary'} />
                                                :
                                                currentSubscription == 0 ? tier.buttonText : currentSubscription > 0 && currentSubscriptionPlanName == tier.title ? 'Current Plan' : 'Contact Sales'
                                        }
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <Container maxWidth="lg" component="main">
                <Grid container alignItems="flex-end">
                    <div className="d-flex flex-row justify-content-center m-5 w-100">
                        <Typography variant="h3">Add-ons</Typography>
                    </div>
                    <Grid
                        item
                        key={'demo'}
                        xs={12}
                        sx={{ borderRadius: 15 }}
                        className="bg-white row mb-5 p-4 shadow"
                    >
                        <div className="col-12 col-lg-8">
                            <div className="d-flex flex-column justify-content-center align-items-start h-100">
                                <CardContent className="py-0">
                                    <Typography variant="h5">
                                        Additional professionally hosted Discovery Calls
                                    </Typography>
                                </CardContent>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                <Typography>$500 per Discovery Call</Typography>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
            {/* Footer */}
            <Container
                maxWidth="md"
                component="footer"
                sx={{
                    borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                    mt: 8,
                    py: [3, 6],
                }}
            >
                {/* <Grid container spacing={4} justifyContent="space-evenly">
          {footers.map((footer) => (
            <Grid item xs={6} sm={3} key={footer.title}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                {footer.title}
              </Typography>
              <ul>
                {footer.description.map((item) => (
                  <li key={item}>
                    <Link href="#" variant="subtitle1" color="text.secondary">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </Grid>
          ))}
        </Grid> */}
                <Copyright sx={{ mt: 5 }} />
            </Container>
            {/* End footer */}
        </React.Fragment>
    );
}

export default function Subscription() {
    return <div></div>;
}